import React from 'react';
import { useHistory } from 'react-router';
import en from '../../lang/en-us';
import { isMobileDevice } from '../../utils/constants';

const { footer } = en;

export default function Footer() {
    const history = useHistory();
    return (
        <footer>
            <div className="maxWidth">
                <p className="copyright">{footer.copyRightText}</p>
                <ul>
                    <li>
                        <a
                            onClick={() => {
                                isMobileDevice()
                                    ? history.push('/links/terms-of-use')
                                    : window.open(`/links/terms-of-use`, '_blank');
                            }}
                        >
                            {footer.actions.termsOfUse.title}
                        </a>
                    </li>
                    <li>
                        <a
                            onClick={() => {
                                isMobileDevice()
                                    ? history.push('/links/privacy-policy')
                                    : window.open(`/links/privacy-policy`, '_blank');
                            }}
                        >
                            {footer.actions.privacy.title}
                        </a>
                    </li>
                    {/* <li>
                        <a href="#">{footer.actions.termsOfBusiness.title}</a>
                    </li> */}
                </ul>
                <p className="developedby">{footer.siteDeveloper.title}</p>
            </div>
        </footer>
    );
}
